import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef } from './routes';

export const doraDashboardPage = PageBlueprint.make({
  params: {
    noHeader: true,
    path: '/dashboards/dora',
    routeRef: rootRouteRef,
    loader: () => import('./dashboard-page').then(m => <m.DashboardPage />),
  },
});

export const doraDashboardPlugin = createFrontendPlugin({
  pluginId: 'dora-dashboard',
  extensions: [doraDashboardPage],
  routes: {
    root: rootRouteRef,
  },
});
